export default "__VITE_ASSET__BEkD516G__"